import React, { useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import MenuItem from "@material-ui/core/MenuItem";
import { compose } from "recompose";
import { disableUser } from "../../../redux/actions";

const DisableAdministratorMenuItem = ({
  onComplete,
  administrator,
  disable,
}) => {
  useEffect(() => {}, []);

  const onClick = () => {
    disable(administrator.id);
    onComplete();
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      Disable
    </MenuItem>
  );
};

const mapDispatchToProps = (dispatch) => ({
  disable: (id) => dispatch(disableUser(id)),
});

const enhance = compose(connect(undefined, mapDispatchToProps), injectIntl);

export default enhance(DisableAdministratorMenuItem);
